<template>
  <div>
    <div class="mainContent">
      <a-form-model :layout="layout" style="width:100%;" ref="ruleForm" :model="form">
          <a-col :sm="24" :md="12" :lg="8" :xl="6">
            <a-form-model-item label="服务器名称" colon :labelCol='labelcol' :wrapperCol="wrappercol" prop="server_name">
              <a-input v-model="form.server_name" placeholder="请输入服务器名称..." />
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :lg="8" :xl="6">
            <a-form-model-item label="IP地址" colon :labelCol='labelcol' :wrapperCol="wrappercol" prop="ip">
              <a-input v-model="form.ip" placeholder="请输入IP地址..." />
            </a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :lg="8" :xl="6">
            <a-form-model-item label="服务器状态" :labelCol='labelcol' :wrapperCol="wrappercol" prop="is_delete">
              <a-select v-model="form.is_delete" placeholder="请选择服务器状态..." :options='is_delete'>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :lg="8" :xl="6" class="lyq_flex_grow">
            <a-form-model-item style="text-align:right;">

              <a-button type="primary" @click="search">
                搜索
              </a-button>
              <a-button @click="reset('ruleForm')">重置</a-button>

            </a-form-model-item>
          </a-col>
      </a-form-model>
    </div>
    <div class="mainContent" style="display: flex;justify-content: space-between;">
      <div>
        <a-button type="primary" @click="updataWeb" :disabled="!selectedRowKeys.length > 0">
          更新工具包
        </a-button>
      </div>
      <a-button type="primary" @click="onAdd">
        添加服务器
      </a-button>
    </div>
    <div class="mainContent" >

      <div class="tableHeader">
        <div class="title">查询表格</div>
        <div class="operate">

          <a-tooltip placement="top">
            <template slot="title">
              <span>下载</span>
            </template>
            <a class="ant-dropdown-link" style="display:block;margin-right:10px;" @click="start" :disabled="!selectedRowKeys.length > 0">
              <a-icon type="vertical-align-bottom" />
            </a>
          </a-tooltip>

          <a-tooltip placement="top">
            <template slot="title">
              <span>表格大小</span>
            </template>
            <a-dropdown :trigger="['click']" style="margin-right:10px;">
              <a class="ant-dropdown-link" style="display:block">
                <a-icon type="column-height" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="tableSize='default'">默认</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="tableSize='middle'">中等</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="tableSize='small'">紧凑</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-tooltip>

        </div>
      </div>

      <a-table
        :size="tableSize"
        :scroll="{ x: true }"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :row-key="record => record.server_id"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        bordered
        @change="handleTableChange"
      >
        <!-- 状态单元格 -->
        <template slot="is_delete" slot-scope="data,record">
          <a-tag :color="record.is_delete=='0'?'green':'red'">
              {{record.is_delete|statusFilter}}
          </a-tag>
        </template>
        <!-- 操作单元格 -->
        <template slot="操作" slot-scope="data">

              <span>

                <a-button size="small" type="primary"  @click="onEdit(data)">编辑</a-button>

                <a-popconfirm v-if="data.is_delete=='0'" title="是否禁用此服务器?" @confirm="() => onDisable(data)">
                  <a-button size="small" type="danger">禁用</a-button type="primary" >
                </a-popconfirm>
                <a-popconfirm v-else title="是否启用此服务器?" @confirm="() => onEnable(data)">
                  <a-button size="small" type="primary" class="greenBtn">启用</a-button type="primary">
                </a-popconfirm>

              </span>

        </template>
      </a-table>
    </div>

  <!-- 修改帐号信息模态框 -->
  <a-modal

      :title="title"
      :visible="editModalVisible"
      :confirm-loading="confirmLoading"
      @ok="save"
      @cancel="cancel"
    >
      <!-- 编辑 -->
      <a-form-model
        ref="servers"
        :model="editForm"
        :rules="editFormRules"
        :label-col="{span:7}"
        :wrapper-col="{span:17}"
      >
        <a-form-model-item label="服务器名称" prop="server_name">
          <a-input v-model="editForm.server_name" placeholder="请输入服务器名称..."/>
        </a-form-model-item>
        <a-form-model-item label="服务器密码" prop="password">
          <a-input v-model="editForm.password" placeholder="请输入服务器密码..."/>
        </a-form-model-item>

        <a-form-model-item label="数据库密码" prop="db_password">
          <a-input v-model="editForm.db_password" placeholder="请输入数据库密码..."/>
        </a-form-model-item>

        <a-form-model-item label="IP地址" prop="ip">
          <a-input v-model="editForm.ip" placeholder="请输入IP地址..."/>
        </a-form-model-item>



        <a-form-model-item label="状态" prop="is_delete" v-if="title=='编辑服务器'">
          <a-select v-model.Number="editForm.is_delete" placeholder="请选择服务器状态..." :options='is_delete_edit'>

          </a-select>
        </a-form-model-item>
      </a-form-model>
  </a-modal>

  </div>
</template>
<script>
import {getServersList,editServers,addServers,deleteServers,updateTools} from "@/axios/servers.js"
import {myMixin} from "@/static/js/mixin.js"
import moment from 'moment';
const columns = [//列描述
  {
    align:'center',
    title: '服务器ID',
    dataIndex: 'server_id',
  },
  {
    align:'center',
    title: '服务器名称',
    dataIndex: 'server_name',
  },
  {
    align:'center',
    title: '服务器密码',
    dataIndex: 'password',
  },
  {
    align:'center',
    title: 'IP地址',
    dataIndex: 'ip',
  },

  {
    align:'center',
    title: '数据库密码',
    dataIndex: 'db_password',
  },
  {
    align:'center',
    title: '状态',
    dataIndex: 'is_delete',
    scopedSlots: { customRender: 'is_delete', },
  },
  {
    align:'center',
    title: '操作',
    // dataIndex: 'status',
    scopedSlots: { customRender: '操作', },
  },

];
export default {
  filters: {

    statusFilter(status) {
      const statusMap = {
        0: '启用',
        1: '禁用',
      }

      return statusMap[status]

    },
  },
  mixins: [myMixin],
  data() {

    return {
      is_delete_edit: [
        {
            value: 0,
            label: '启用'
        },
        {
            value: 1,
            label: '禁用'
        },
      ],
      is_delete: [
        {
            value: -1,
            label: '全部'
        },
        {
            value: 0,
            label: '启用'
        },
        {
            value: 1,
            label: '禁用'
        },
      ],

      form: {
        page_size: 10,
        page:1,
        server_name: '',
        is_delete:-1,
        ip:''
      },

      columns,//列描述

      confirmLoading:false,//编辑模态框
      editModalVisible:false,
      editForm:{
        db_password:'',
        server_name:'',
        ip:'',
        password:'',
        is_delete:-1,
      },
      editFormRules: {
        server_name: [
          { required: true, message: '请输入服务器名', trigger: 'blur' },
        ],
        ip: [
          { required: true, message: '请输入IP地址', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入服务器密码', trigger: 'blur' },
        ],
        db_password: [
          { required: true, message: '请输入数据库密码', trigger: 'blur' },
        ],
        is_delete: [
          { required: true, message: '请选择用户状态', trigger: 'change' },
        ],
      },

      title:'编辑服务器',

    }

  },
  mounted() {
    let that=this
    this.fetch();
  },
  methods:{

      async fetch (params = {}) {
        this.loading = true;
        let data=await getServersList({...params,...this.form})
        this.loading = false;
        const pagination = { ...this.pagination };
        pagination.total = data.data.total;
        this.data = data.data.list;
        this.pagination = pagination;
      },

      //添加用户数据
      onAdd(){
        this.editModalVisible=true
        this.title='添加服务器'
      },

      //禁用服务器
      async onDisable(data){
        data.is_delete=1
        let resule=await editServers({...data});
          if(resule.status==1){
            this.$message.success(resule.errmsg);
            this.fetch()
          }else{
            this.$message.error(resule.errmsg);
        }
      },
      //启用服务器
      async onEnable(data){
        data.is_delete=0
        let resule=await editServers({...data});
          if(resule.status==1){
            this.$message.success(resule.errmsg);
            this.fetch()
          }else{
            this.$message.error(resule.errmsg);
        }
      },
      //编辑保存用户数据
      onEdit(data){
        this.title='编辑服务器'
        this.editModalVisible=true
        this.$nextTick(()=>{
           this.editForm={...data}
        })
        console.log(this.editForm,'data')

      },
      save(){
        this.$refs.servers.validate( async valid => {
        if (valid) {
          this.confirmLoading = true;
          let resule
          if(this.title=='添加服务器'){
            const {is_delete,...rest} = this.editForm;
            resule=await addServers(rest);
          }else{
            resule=await editServers({...this.editForm});
          }

          this.confirmLoading = false;
          if(resule.status==1){
            console.log(resule)
            this.$message.success(resule.errmsg);
            this.editModalVisible = false;
            this.$refs.servers.resetFields();
            this.fetch();
          }else{
            this.$message.error(resule.errmsg);
          }

        } else {
          return false;
        }
      });


      },
      cancel(){
        this.$refs.servers.resetFields();
        this.editModalVisible = false;
      },
      updataWeb(){
        updateTools({server_ids:this.selectedRowKeys.join(',')}).then((resule)=>{

            if(resule.status==1){
              console.log(resule)
              this.$message.success('更新成功');
            }else{
              this.$message.error(resule.errmsg);
            }
          });

      }
    }
};
</script>
<style lang="scss" scoped>
@import "@/static/css/index.scss";
.ant-table td { white-space: nowrap; }
.ant-table td .greenBtn{background-color:#7ac141;border-color:#7ac141;}
</style>
